import React from "react";
import {injectIntl} from "react-intl";
import { Modal, DatePicker, Button, Space, Spin, Typography, message } from "antd";
import moment from "moment";
import Context from "../../../Context";

const { Text } = Typography;

class HeaderOperDate extends React.Component {
  static contextType = Context;

  state = {
    loading: false,
    changing: false,
    visible: false,
    // Текущее значение (для отображения в хедере)
    operDateIso: null,     // string | null (например "2025-10-09T23:11:00+03:00")
    // Значение в пикере
    inputValue: null,      // moment | null
  };

  componentDidMount() {
    this.load();
  }

  load = async () => {
    try {
      this.setState({ loading: true });
      const resp = await this.context.api.q("/current/oper_date");
      const iso = resp?.oper_date || null;

      this.setState({
        loading: false,
        operDateIso: iso,
        inputValue: iso ? moment(iso) : null, // локальное время для пользователя
      });
    } catch (e) {
      this.setState({ loading: false });
      message.error("Не удалось загрузить дату операционного дня");
    }
  };

  openModal = () => this.setState({ visible: true });
  closeModal = () => {
    if (!this.state.changing) this.setState({ visible: false });
  };

  onPickerChange = (value) => {
    this.setState({ inputValue: value });
  };

  // Единая рассылка события + вызов пропса onChange
  broadcastChange = (date) => {
    if (typeof this.props.onChange === "function") {
      this.props.onChange(date);
    }
  };

  setDate = async () => {
    const { inputValue } = this.state;
    if (!inputValue) {
      message.warning("Выберите дату");
      return;
    }
    try {
      this.setState({ changing: true });

      // Отправляем строку с локальным смещением, а НЕ Date
      // Пример: "2024-01-01T00:00:34+03:00"
      const isoToSend = inputValue.format("YYYY-MM-DDTHH:mm:ssZ");

      const result = await this.context.api.q("/session/set/oper_date", {
        oper_date: isoToSend,
      });

      const savedIso = result?.oper_date || isoToSend;

      // Обновляем локально и рассылаем событие вместо перезагрузки
      this.setState({
        changing: false,
        operDateIso: savedIso,
        inputValue: savedIso ? moment(savedIso) : null,
        visible: false,
      });
      this.broadcastChange(savedIso);
      message.success("Дата операционного дня установлена");
      this.load();
    } catch (e) {
      this.setState({ changing: false });
      message.error("Ошибка при установке даты");
    }
  };

  resetDate = async () => {
    try {
      this.setState({ changing: true });
      const result = await this.context.api.q("/session/set/oper_date", {
        oper_date: null,
      });

      const savedIso = result?.oper_date ?? null;

      this.setState({
        changing: false,
        operDateIso: savedIso,
        inputValue: null,
        visible: false,
      });
      this.broadcastChange(savedIso);
      message.success("Дата операционного дня сброшена");
      this.load();
    } catch (e) {
      this.setState({ changing: false });
      message.error("Ошибка при сбросе даты");
    }
  };

  renderCurrent() {
    const { operDateIso, loading } = this.state;
    const text = operDateIso
      ? moment(operDateIso).format("DD.MM.YYYY HH:mm")
      : "Установить дату";

    return (
      <div
        className="gx-d-flex gx-align-items-center"
        title="Дата операционного дня"
        style={{ cursor: loading ? "default" : "pointer", opacity: loading ? 0.6 : 1 }}
        onClick={loading ? undefined : this.openModal}
      >
        <span className="gx-text-primary gx-text-ellipsis" style={{ maxWidth: 200 }}>
          {text}
        </span>
      </div>
    );
  }

  renderModal() {
    const { visible, inputValue, changing, operDateIso } = this.state;

    return (
      <Modal
        title="Дата операционного дня"
        open={visible}
        onCancel={this.closeModal}
        footer={null}
        destroyOnClose
        maskClosable={!changing}
      >
        <Spin spinning={changing}>
          <Space direction="vertical" size="middle" style={{ width: "100%" }}>
            <div>
              <Text type="secondary">Установите дату и время при необходимости</Text>
              <div style={{ marginTop: 8 }}>
                <DatePicker
                  showTime
                  value={inputValue}
                  onChange={this.onPickerChange}
                  format="DD.MM.YYYY HH:mm:ss"
                  style={{ width: "100%" }}
                  allowClear
                />
              </div>
            </div>
            <Space style={{ display: "flex", justifyContent: "flex-end" }}>
              {operDateIso ? (
                <Button danger onClick={this.resetDate} disabled={changing}>
                  Сбросить
                </Button>
              ) : null}
              <Button type="primary" onClick={this.setDate} disabled={changing}>
                {operDateIso ? "Изменить" : "Установить"}
              </Button>
            </Space>
          </Space>
        </Spin>
      </Modal>
    );
  }

  render() {
    return (
      <>
        {this.renderCurrent()}
        {this.renderModal()}
      </>
    );
  }
}

export default injectIntl(HeaderOperDate);
